import React from 'react';

/**
 * Pricing tiles for the Funeral Professional program page.
 *
 * Mirrors the CREDIT_PACKAGES object in `backend/fdRoutes.js` — if
 * those prices ever change this module needs a matching bump. Copy
 * kept in sync with the landing page's "75¢ to $1 per obituary"
 * headline promise.
 */

const PACKAGES = [
  { credits: 50,    priceCents: 5000,   tag: null,          note: 'Try it out' },
  { credits: 100,   priceCents: 9000,   tag: null,          note: 'Most small firms' },
  { credits: 500,   priceCents: 42500,  tag: 'Popular',     note: 'Mid-size firms' },
  { credits: 1000,  priceCents: 80000,  tag: null,          note: 'Multi-location' },
  { credits: 5000,  priceCents: 375000, tag: 'Best value',  note: 'Chains / groups' },
];

const fmtMoney = (cents) =>
  cents % 100 === 0
    ? '$' + (cents / 100).toLocaleString()
    : '$' + (cents / 100).toFixed(2);

const perObit = (priceCents, credits) => {
  const p = priceCents / credits / 100;
  return p >= 1
    ? '$' + p.toFixed(2)
    : Math.round(p * 100) + '¢';
};

const FdPricingTiles = () => {
  return (
    <div className="fd-pricing-wrap" aria-labelledby="fd-pricing-heading">
      <div className="fd-pricing-head">
        <span className="fd-auth-badge">Pricing</span>
        <h2 id="fd-pricing-heading" className="fd-pricing-title">
          75¢ to $1 per obituary. Credits never expire.
        </h2>
        <p className="fd-pricing-sub">
          Your firm pays once per pack, uses credits as families come
          through the door, and keeps anything unused for the next
          slow month. No seats, no per-user fees, no auto-renew.
        </p>
      </div>

      <div className="fd-pricing-grid" role="list">
        {PACKAGES.map((p) => (
          <div
            key={p.credits}
            className={`fd-pricing-tile ${p.tag ? 'is-featured' : ''}`}
            role="listitem"
          >
            {p.tag && <span className="fd-pricing-tag">{p.tag}</span>}
            <div className="fd-pricing-credits">
              {p.credits.toLocaleString()}
              <span className="fd-pricing-credits-unit">credits</span>
            </div>
            <div className="fd-pricing-price">{fmtMoney(p.priceCents)}</div>
            <div className="fd-pricing-each">
              {perObit(p.priceCents, p.credits)} / obituary
            </div>
            <div className="fd-pricing-note">{p.note}</div>
          </div>
        ))}
      </div>

      <div className="fd-pricing-foot">
        <span className="fd-pricing-foot-star">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        </span>
        New firms start with <strong>30 free credits</strong>. No card required to sign up.
        You only pay when you buy more.
      </div>
    </div>
  );
};

export default FdPricingTiles;
